var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _circle3, _circle4, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134,
    height: 61,
    viewBox: "0 0 134 61",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.1816,
    y: 0.5,
    width: 21.8182,
    height: 5.45455,
    rx: 2.72727,
    fill: "#FFDEDE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.1816,
    y: 11.4092,
    width: 34.5455,
    height: 5.45455,
    rx: 2.72727,
    fill: "#FFDEDE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100.637,
    y: 2.31836,
    width: 9.09091,
    height: 5.45455,
    rx: 2.72727,
    fill: "#FFDEDE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 124.273,
    y: 25.9546,
    width: 9.09091,
    height: 5.45455,
    rx: 2.72727,
    fill: "#FFDEDE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 84.2734,
    y: 24.1362,
    width: 36.3636,
    height: 5.45455,
    rx: 2.72727,
    fill: "#FFDEDE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 84.2734,
    y: 36.8638,
    width: 27.2727,
    height: 5.45455,
    rx: 2.72727,
    fill: "#FFDEDE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 36.8638,
    width: 32.7273,
    height: 5.45455,
    rx: 2.72727,
    fill: "#FFDEDE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.636719,
    y: 49.5908,
    width: 56.3636,
    height: 5.45455,
    rx: 2.72727,
    fill: "#FFDEDE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.7282,
    cy: 11.4088,
    r: 3.63636,
    fill: "#FFDEDE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.1823,
    cy: 47.7726,
    r: 3.63636,
    fill: "#FFDEDE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.455,
    cy: 18.682,
    r: 1.81818,
    fill: "#FFDEDE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.9096,
    cy: 35.0454,
    r: 25.4545,
    fill: "#FFDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.1179 29.2846L61.3204 45.0821C60.7807 45.6218 59.8855 45.6218 59.3457 45.0821C58.806 44.5423 58.806 43.6471 59.3457 43.1074L75.1432 27.3099C75.683 26.7702 76.5781 26.7702 77.1179 27.3099C77.6576 27.8497 77.6576 28.7449 77.1179 29.2846Z",
    fill: "#E14949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1179 45.0846C76.5781 45.6244 75.683 45.6244 75.1432 45.0846L59.3457 29.2871C58.806 28.7474 58.806 27.8522 59.3457 27.3125C59.8855 26.7727 60.7807 26.7727 61.3204 27.3125L77.1179 43.1099C77.6576 43.6497 77.6576 44.5449 77.1179 45.0846Z",
    fill: "#E14949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIcon);
export default __webpack_public_path__ + "static/media/reject-icon.436bdffa0b12935f6e94ddadfc84f500.svg";
export { ForwardRef as ReactComponent };